import { render, staticRenderFns } from "./BankcardForm.vue?vue&type=template&id=54e2bc54&"
import script from "./BankcardForm.vue?vue&type=script&lang=js&"
export * from "./BankcardForm.vue?vue&type=script&lang=js&"
import style0 from "./BankcardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BankcardForm.vue"
export default component.exports